import type {ValueOf} from 'type-fest';
import type {OnyxServerUpdate} from '@src/types/onyx/OnyxUpdatesFromServer';

const NotificationType = {
    REPORT_COMMENT: 'reportComment',
    MONEY_REQUEST: 'moneyRequest',
} as const;

type NotificationDataMap = {
    [NotificationType.REPORT_COMMENT]: ReportActionPushNotificationData;
    [NotificationType.MONEY_REQUEST]: ReportActionPushNotificationData;
};

type PushNotificationData = ReportActionPushNotificationData;

type BasePushNotificationData = {
    title: string;
    type: ValueOf<typeof NotificationType>;
    onyxData?: OnyxServerUpdate[];
    lastUpdateID?: number;
    previousUpdateID?: number;
};

type ReportActionPushNotificationData = BasePushNotificationData & {
    reportID: number;
    reportActionID: string;
    roomName?: string;
};

/**
 * See https://github.com/Expensify/Web-Expensify/blob/main/lib/MobilePushNotifications.php for the various
 * types of push notifications sent by our API.
 */
export default NotificationType;
export type {NotificationDataMap, PushNotificationData, ReportActionPushNotificationData};
